import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { Chart } from "chart.js";
import { BlogService } from "../../services/blog.service";
import { Blog } from "../../models/blog";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { DASHBOARD, PAGES, TYPE_LIST } from "../constants/constants";
import { CategoryService } from "src/app/services/categories.service";
import { Category } from "src/app/models/category";
import { Router, ActivatedRoute } from "@angular/router";
import { MessageService } from "primeng/api";
import { Clients } from "src/app/models/clients";
import { Appointments } from "src/app/models/appointments";
import * as $ from "jquery";
import { formatDate } from "@angular/common";
import { Locations } from "src/app/models/locations";
import { Employees } from "src/app/models/employees";
import { Works } from "src/app/models/works";
import moment from "moment";
import { Billings } from "src/app/models/billings";
import { NgxSpinnerService } from "ngx-spinner";
import "moment/locale/it"; // without this line it didn't work
import { SupportsService } from "src/app/services/supports.service";
import { Supports } from "src/app/models/supports";
import { Projects } from "src/app/models/projects";

import { WarehouseCheckins } from "src/app/models/warehouse_checkins";
import { NewsService } from "src/app/services/news.service";
import { News } from "src/app/models/news";
import { StartupsService } from "src/app/services/startups.service";
import { Requests } from "src/app/models/requests";
import { Startups } from "src/app/models/startups";
import { UsersService } from "src/app/services/users.service";
import { Users } from "src/app/models/users";
import { StartupsLikesService } from "src/app/services/startups_likes.service";
import { Startups_likes } from "src/app/models/startups_likes";
import { StartupsReviewService } from "src/app/services/startups_review.service";
import { Reviews } from "src/app/models/review";
import { EventsService } from "src/app/services/events.service";
import { CorsiService } from "src/app/services/corsi.service";
import { Events } from "src/app/models/events";
import { Corsi } from "src/app/models/corsi";
import { environment } from "src/environments/environment";
import { RequestsService } from "src/app/services/requests.service";

import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { DrawerModule } from "primeng/drawer";
import { NgClass } from "@angular/common";
import { Ripple } from "primeng/ripple";
import { RouterLink } from "@angular/router";
import { SharedModule } from "primeng/api";
import { TableModule } from "primeng/table";
import { TabsModule } from "primeng/tabs";
import { TagModule } from "primeng/tag";
import { TopNavComponent } from "../../top-nav/top-nav.component";

moment.locale("it");

@Component({
    selector: "app-admin-dashboard",
    templateUrl: "./admin-dashboard.component.html",
    imports: [ButtonModule, CardModule, DrawerModule, NgClass, Ripple, RouterLink, SharedModule, TableModule, TabsModule, TagModule, TopNavComponent]
})
export class AdminDashboardComponent implements OnInit {
  calendarOptions: any;
  events: Events[];
  newss: News[];
  corsi: Corsi[];

  clientsCount: any;
  supports: any = [];
  support: Supports;

  billings: any = [];
  billing: Billings;

  startups: Startups[] = [];
  startup: Startups;
  likes: Startups_likes[] = [];
  reviews: Reviews[] = [];
  news: News[] = [];

  productsCount: any;
  error: string;
  blogForm: UntypedFormGroup;
  typeList: any;
  cities: Blog[];
  format1: string = "";
  format2: string = "";
  selectedCity: Blog;
  uploadError: string;
  selectedCategories: Category;
  selectedDate: Date;
  date: Date;
  selectedWorks: any[];
  categories: any = [];
  category: Category;
  productDialog: boolean = false;
  appointmentsDialog: boolean = false;
  users: Users[] = [];
  requests: Requests[] = [];
  clientsWorks: any = [];
  user: Users;
  comuni: any = [];
  displayEvent: any;
  currentUser: any;
  items: any;
  appointmentsCount: Appointments;
  billingsCount: Billings;
  billingsCountTotal: Billings;
  projects: any = [];
  project: Projects;
  billingsCountTotalNotPaid: Billings;
  category_id: string;
  canvas: any;
  ctx: any;
  yAxes: [];
  xAxes: [];
  chartsCount: any;
  chartsCountNone: any;
  chartsCountData: any = [];
  chartsCountDataTotal: string;
  data1 = [];
  data2 = [];
  count = 0;
  countStartups = 0;
  countNews = 0;
  countClients = 0;
  countLikes = 0;
  countCorsi = 0;
  countEvents = 0;
  countRequest = 0;
  countClientsWorks = 0;
  request: Requests;
  pageSize = 3;
  page = 1;
  myDate = formatDate(new Date(), "dd/MM/yyyy", "en");
  searchDate = formatDate(new Date(), "yyyy-MM-dd", "en");
  cols: any[];
  colsData: any[];

  trackByFn(index, item) {
    return item.id;
  }

  myMonth = formatDate(new Date(), "dd/MM/yyyy", "en");
  nameFilter: string;
  descriptionFilter: string;
  dateFromFilter: string;
  dateToFilter: string;
  currentDate: moment.Moment = moment();
  currentTime: string = moment().format(" MMMM YYYY");
  imageUrl: string;

  constructor(
    private spinner: NgxSpinnerService,
    private eventsService: EventsService,
    private newsService: NewsService,
    private corsiServic: CorsiService,
    private usersService: UsersService,
    private requestsService: RequestsService
  ) {
    this.typeList = TYPE_LIST;
    this.currentUser = JSON.parse(localStorage.getItem("currentUser") || "[]");
    this.items = DASHBOARD;
    this.imageUrl = environment.news_image_url;
  }

  ngOnInit() {
    const userId = this.currentUser.user_id;
    this.spinner.show();
    this.getEvents();
    this.getNews();
    this.getRequests();
    this.getCorsi();

    this.cols = [{ field: "page_title", header: "Titolo" }];

    this.spinner.hide();
  }

  ngAfterViewInit() {
    //this.getChartsCount();
    //this.chartCanvas();
  }

  goToUrl(startup_url: any): void {
    window.open(startup_url, "_blank");
  }

  getRequestParams(page, searchTitle, categoryTitle, pageSize): any {
    // tslint:disable-next-line:prefer-const
    const params = {};
    let adder = "?";
    if (page) {
      params[`page`] = page - 1;
      adder + "page=" + (page - 1);
      adder = "&";
    }
    if (searchTitle) {
      params[`name`] = searchTitle;
      adder + "date_from=" + searchTitle;
      adder = "&";
    }
    if (categoryTitle) {
      params[`description`] = categoryTitle;
      adder + "date_to=" + categoryTitle;
      adder = "&";
    }
    if (pageSize) {
      params[`size`] = pageSize;
      adder + "size=" + pageSize;
    }

    return params;
  }

  hasRole(role: string): boolean {
    const user = JSON.parse(localStorage.getItem("currentUser") || "[]");
    return user.roles && user.roles.includes(role);
  }

  getEvents() {
    const paramsEvents = {
      page: 0,
      size: 7,
      page_template: "events",
    };

    this.newsService.list(paramsEvents).subscribe((pData) => {
      this.events = pData;
      this.countEvents = this.newsService.size;
    });
  }

  getRequests() {
    const paramsRequests = {
      page: 0,
      limit: 4,
    };

    this.requestsService.list(paramsRequests).subscribe((pData) => {
      this.requests = pData;
      this.countRequest = this.requestsService.size;
    });
  }

  getCorsi() {
    const paramsCorsi = {
      page: 0,
      limit: 4,
    };

    this.corsiServic.list(paramsCorsi).subscribe((pData) => {
      this.corsi = pData;
      this.countCorsi = this.corsiServic.size;
    });
  }

  getNews() {
    const paramsNews = {
      page: 0,
      limit: 4,
      page_template: "news",
    };

    this.newsService.list(paramsNews).subscribe((pData) => {
      this.newss = pData;
      this.countNews = this.newsService.size;
    });
  }

  edit(request: Requests) {
    this.request = { ...request };
    this.productDialog = true;
  }
}
